import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MainContext } from "../../../main/context/MainContextProvider";
import { createAnalyticsPageTracker } from "../../helpers/GoogleAnalytics";

export const RoutesTracker = () => {
    const { userIsLogged } = useContext(MainContext);

    const location = useLocation();

    const pageTracker = createAnalyticsPageTracker();

    useEffect(() => {
        if (!userIsLogged) {
            console.debug("User not authenticated");
            return;
        }
        pageTracker(location.pathname + location.search, location.pathname);
    }, [location]);

    return <></>;
};
